/**
 * Resolve the omnium-admin REST base URL.
 *
 * This used to be server-only (``ADMIN_API_BASE_URL``, deliberately not a
 * NEXT_PUBLIC_ var) because the browser never called the admin API — a Next
 * server did, from inside the network. The admin UI is a static SPA now, so
 * there is no server left to call it: the browser talks to the admin service
 * directly and the URL has to reach the bundle.
 *
 * That is why the admin service grew CORS (``ADMIN_CORS_ORIGINS``). Without a
 * matching origin there the browser blocks every one of these requests before
 * it leaves the tab.
 *
 * Inlined at build time, so one bundle belongs to exactly one environment.
 */
export function getAdminApiBaseUrl(): string {
  const raw = import.meta.env.VITE_ADMIN_API_BASE_URL ?? "http://localhost:8001";
  return raw.replace(/\/$/, "");
}
